export default __webpack_public_path__ + "static/media/check-white.4fef8c3b.svg";